// Header search: "Search for <word>" where the word spins in and changes every couple of seconds.
// The prompt hides while the field is focused or has text.
document.querySelectorAll('[data-search-prompt]').forEach((prompt) => {
  const words = (prompt.dataset.words || '').split(',').map((w) => w.trim()).filter(Boolean);
  const wordEl = prompt.querySelector('[data-search-prompt-word]');
  const input = prompt.closest('form')?.querySelector('input[name="q"]');
  if (!words.length || !wordEl || !input) return;

  let focused = false;
  const refresh = () => { prompt.hidden = focused || input.value.trim() !== ''; };
  input.addEventListener('focus', () => { focused = true; refresh(); });
  input.addEventListener('blur', () => { focused = false; refresh(); });
  input.addEventListener('input', refresh);
  refresh();

  let index = 0;
  const spin = () => {
    index = (index + 1) % words.length;
    wordEl.textContent = words[index];
    wordEl.classList.remove('is-spinning');
    void wordEl.offsetWidth;
    wordEl.classList.add('is-spinning');
  };
  wordEl.classList.add('is-spinning');
  if (words.length > 1) setInterval(() => { if (!prompt.hidden && !document.hidden) spin(); }, 2400);
});
